<template>
    <div>
        <h2>Advertisement</h2>
        <ElDivider/>

        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                border
                stripe
                class="data-table"
                @row-click="openEdit"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'name',label:'Name'},
                        {prop:'score',label:'Score'},
                        {prop:'contact',label:'Contact'},
                        {prop:'sort',label:'Sort'},
                        {prop:'evaluateNum',label:'Evaluate Num'},
                        {prop:'updateTime',label:'Updated Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="900px">
            <el-form ref="form" label-position="left" label-width="120px" :model="form" :rules="rules">
                <el-form-item prop="name" label="Name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item prop="contact" label="Contact">
                    <el-input v-model="form.contact"></el-input>
                </el-form-item>

                <el-form-item prop="about" label="About">
                    <el-input type="textarea" autosize v-model="form.about"></el-input>
                </el-form-item>

                <el-form-item prop="icon" label="Icon">
                    <icon-uploader :url.sync="form.icon"></icon-uploader>
                </el-form-item>

                <el-form-item prop="advBanner" label="Banner">
                    <icon-uploader :url.sync="form.advBanner"></icon-uploader>
                </el-form-item>

                <el-form-item prop="banner" label="Banners">
                    <image-uploader :updatedFiles.sync="form.banner"></image-uploader>
                </el-form-item>

                <el-form-item prop="prices" label="Prices">
                    <div v-for="(p,index) in prices" :key="'afv'+index">
                        <el-row>
                            <el-col :span="10">
                                <el-input v-model="p.item" :key="'in'+index">
                                    <template slot="prepend">Item Name</template>
                                </el-input>
                            </el-col>
                            <el-col :span="10">
                                <el-input v-model="p.price" :key="'p-i'+index">
                                    <template slot="prepend">Price</template>
                                </el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button v-if="index ===0" type="warning" size="mini" @click="addItem(prices)"
                                           icon="el-icon-plus"></el-button>
                                <el-button type="danger" size="mini" @click="deleteItem(prices,index)"
                                           icon="el-icon-delete"></el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item prop="businessHours" label="Business Hours">
                    <div v-for="(p,index) in businessHours" :key="'amv'+index">
                        <el-row>
                            <el-col :span="10">
                                <el-input v-model="p.day">
                                    <template slot="prepend">Day</template>
                                </el-input>
                            </el-col>
                            <el-col :span="10">
                                <el-input v-model="p.time">
                                    <template slot="prepend">Time</template>
                                </el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button v-if="index ===0" type="warning" size="mini"
                                           @click="addItem(businessHours)"
                                           icon="el-icon-plus"></el-button>
                                <el-button type="danger" size="mini" @click="deleteItem(businessHours,index)"
                                           icon="el-icon-delete"></el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item prop="sort" label="Sequence">
                    <el-input-number v-model="form.sort"></el-input-number>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">Save</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import {adVendorCreate, adVendorList, adVendorUpdate} from '@/api/VendorAPI'
    import IconUploader from "@/components/IconUploader";
    import ImageUploader from "@/components/ImageUploader";

    export default {
        name: "AdVendor",
        components: {ImageUploader, IconUploader},
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                form: {},
                prices: [],
                businessHours: [],
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    year: [
                        {required: true, message: 'Year is required', trigger: 'blur'},
                    ],
                    dayList: [
                        {required: true, message: 'Please input the holidays ', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            addItem(data) {
                data.push({})
            },
            deleteItem(data, index) {
                if (index === 0) {
                    return
                }
                data.splice(index, 1);
            },
            loadData() {
                this.$pageUtils(this, adVendorList)
            },
            openCreate() {
                this.form = {}
                this.form.banner = []
                this.prices = [{}]
                this.businessHours = [{}]
                this.dialogVisible = true
            },
            openEdit(row) {
                this.form = this.$copy(row);
                this.prices = JSON.parse(this.form.prices)
                this.form.banner = JSON.parse(this.form.banner)
                this.businessHours = JSON.parse(this.form.businessHours)
                this.dialogVisible = true
            },
            saveData() {
                const action = this.form.id ? adVendorUpdate : adVendorCreate;
                this.$refs['form'].validate((valid) => {
                    const from = this.$copy(this.form)
                    from.banner = JSON.stringify(this.form.banner)
                    from.prices = JSON.stringify(this.prices)
                    from.businessHours = JSON.stringify(this.businessHours)
                    if (valid) {
                        action(from)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-table{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .el-col{
        padding-right: 5px;
    }
</style>
